import {handleSendFunctionResponseToShotListAgent} from "../services/handleSendFunctionResponseToShotListAgent";
import {updateShotListHistory} from "./updateShotListHistory";

export const changeSingleValue = async (
  index,
  field,
  value,
  updatedChatSession,
  shotListState,
  setShotListState,
  setChatSession,
  userInfo,
  shotListHistory,
  setShotListHistory,
  historyIndex,
  setHistoryIndex
) => {
    const updatedShotListState = [...shotListState]; 
    const updatedShot = { ...updatedShotListState[index], [field]: value }; 
    updatedShotListState[index] = updatedShot;
    updateShotListHistory(
      shotListState,
      setShotListState,
      shotListHistory,
      setShotListHistory,
      historyIndex,
      setHistoryIndex,
      updatedShotListState
    ); 

    const responseMessage = `FunctionResponse: The value of ${field} for shot ${index + 1} (which was at index ${index}) has been changed to ${updatedShotListState[index]?.[field]}}. Confirm that this is the intended change (silently). If not, run it again. If so, respond letting the user know that the change has been made successfully and either provide suggestions for further improvement or ask the user how else you can help.`;
    const response = {
        role: "user",
        parts: [
          {
            text: responseMessage
          }
        ]
    }
    await handleSendFunctionResponseToShotListAgent(response, updatedChatSession, setChatSession, userInfo);
}